import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {graphqlClient} from '@/services/graphqlClient';
import {useListHealthLogMetricsForExportQuery} from '@/services/graphqlHooks';
import {getMetricLabel} from '@/shared/residents/utils/healthLogUtils';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {HealthLogOptions} from '../../utils/definitions/healthLogExport';
import DateRangeOptionsFields from './DateRangeOptionsFields';
import ResidentOptionsFields from './ResidentOptionsFields';

const HealthLogOptionsFields = ({
  form,
}: ExportOptionsFieldsProps<HealthLogOptions>) => {
  const {t} = useTranslation();
  const {data} = useListHealthLogMetricsForExportQuery(graphqlClient);
  const metrics = (data?.listHealthLogMetrics ?? []).filter(
    metric => metric.enabled
  );

  return (
    <>
      <ResidentOptionsFields form={form} />
      <FormField
        control={form.control}
        name="options.metricId"
        render={({field}) => (
          <FormItem>
            <FormLabel required>{t('Measurement type')}</FormLabel>
            <Select value={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('Select measurement type')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {metrics.map(metric => (
                  <SelectItem key={metric.id} value={metric.id}>
                    {getMetricLabel(metric.id)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <DateRangeOptionsFields form={form} />
    </>
  );
};

export default HealthLogOptionsFields;
